import { getUserFilesApiErrorDetail } from '@/user_files/utils/api-error'

/** Shown whenever the failure is not one the API described for users. */
const kSearchFallbackMessage = 'Unable to search this matter. Please try again.'

/**
 * The message a failed search shows.
 *
 * Search failures are rendered in the listing itself, so only a message the API modelled for users
 * is safe to put on screen. Anything else — a validation array, a gateway page — reaches
 * `ApiError.message` as a stringified response body, which is noise to the user and detail we
 * should not surface. The fetchers already report the original to Sentry.
 *
 * Shared by the drive and the add-files picker so the two cannot drift apart on the copy a user
 * sees for the same failure.
 */
export function getSearchErrorMessage(error: unknown): string {
  return getUserFilesApiErrorDetail(error)?.message ?? kSearchFallbackMessage
}
